export default {
	iframeResizer: {
		postMessageOrigin: process.env.DEPLOY_PRIME_URL,
		cruiseResultOrigin: process.env.GATSBY_CRUISERESULT_ORIGIN,
	},
};
